const ContactSection = () => {
  return (
    <section className="flex h-[253px] w-full flex-col items-center justify-center bg-[#d9202e]">
      <div className="flex flex-col items-center justify-center gap-5">
        {/* Section Title */}
        <h2 className="font-['Poppins'] text-2xl font-bold text-white lg:text-3xl">
          Hubungi Kami
        </h2>

        {/* Contact Info */}
        <div
          className="flex cursor-pointer items-center justify-center gap-3 rounded-[15px] bg-white px-8 py-5"
          onClick={() => (window.location.href = 'mailto:halo@yes.co.id')}
        >
          <img
            src="/img/about-us/Group.png"
            alt="Email icon"
            className="object-cover"
          />
          <span className="font-['Poppins'] text-2xl font-semibold text-[#d91f2e] lg:text-3xl">
            halo@yes.co.id
          </span>
        </div>
      </div>
    </section>
  )
}

export default ContactSection
